import React from "react";
import { Headline, SectionContent, Text } from "../../../../components";
import { applyKey } from "../../../../utils";

const TextBodySection = () => {
  return (
    <SectionContent>
      <Headline nivel="2" styleAs="3" text="Texto de corpo" />
      <Headline nivel="3" styleAs="5" text="Texto Padrões" />
      {applyKey(["sm", "md", "lg"], (size) => (
        <>
          <Text textSize={size}>Paragrafo usando text size [{size}].</Text>
          <Text textSize={size} bodyStrong>
            Paragrafo escuro usando text size [{size}].
          </Text>
        </>
      ))}

      <Headline nivel="3" styleAs="5" text="Outras variações" />

      <Text textType="caption">texto de caption</Text>
      <Text textType="lead">texto de lead</Text>

      <Headline nivel="3" styleAs="5" text="Composição" />

      <Text>texto de lead</Text>

      {applyKey(["sm", "md", "lg"], (size) => (
        <>
          <Text textSize={size} as="div">
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Corrupti
              tempore at laudantium. Iste, et optio!
            </p>
            <p>
              Deserunt, delectus nemo quod porro perferendis dolore expedita eos
              qui vero illum eum reiciendis quasi.
            </p>
            <p>
              Minus est error voluptatem saepe. Numquam ducimus quod molestias
              similique neque nesciunt dolores delectus atque?
            </p>
            <p>
              At fugit incidunt nam? Quaerat labore ad tempora impedit est
              doloremque quo iusto aperiam veniam.
            </p>
            <p>
              Quidem veniam harum recusandae quo esse? Minus est ipsam delectus?
              Aperiam numquam excepturi tenetur debitis!
            </p>
          </Text>
        </>
      ))}
    </SectionContent>
  );
};

TextBodySection.propTypes = {};

export default TextBodySection;
